import { useSyncExternalStore } from 'react'

import {
  getSelectedTimezone,
  getStoredTimezone,
  setSelectedTimezone,
  subscribeTimezone,
} from '../utils/timezone.js'

/**
 * Subscribes the calling component to timezone changes so switching zones in
 * the header re-renders timestamps in place — previously the header forced a
 * full `window.location.reload()`, which dropped live call/socket state.
 */
export function useTimezone(): {
  /** Resolved IANA zone every formatter renders in. */
  timezone: string
  /** Raw preference — `'auto'` or an IANA zone. Bind the dropdown to this. */
  stored: string
  setTimezone: (tz: string) => void
} {
  const timezone = useSyncExternalStore(subscribeTimezone, getSelectedTimezone, () => 'UTC')
  const stored = useSyncExternalStore(subscribeTimezone, getStoredTimezone, () => 'auto')
  return { timezone, stored, setTimezone: setSelectedTimezone }
}
